// src/pages/workflow-builder/nodeTypes.js
import React from 'react';
import { Handle, Position } from 'react-flow-renderer';

export function DefaultNode({ id, data }) {
    return (
        <div className="workflow-node-box" style={{ minWidth: '350px', position: 'relative' }}>
            <button className="delete-node-button" onClick={() => data.onDelete(id)}>
                X
            </button>
            <div className="node-title">{data.label || 'Node'}</div>
            {data.subLabel && <div className="node-subtitle">{data.subLabel}</div>}
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}

export function CallNode({ id, data }) {
    return (
        <div className="workflow-node-box call-node" style={{ minWidth: '350px', position: 'relative' }}>
            <button className="delete-node-button" onClick={() => data.onDelete(id)}>
                X
            </button>
            <div className="node-title">{data.label || 'Call'}</div>
            {data.subLabel && <div className="node-subtitle">{data.subLabel}</div>}
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}

export function SMSNode({ id, data }) {
    return (
        <div className="workflow-node-box sms-node" style={{ minWidth: '350px', position: 'relative' }}>
            <button className="delete-node-button" onClick={() => data.onDelete(id)}>
                X
            </button>
            <div className="node-title">{data.label || 'SMS'}</div>
            {data.subLabel && <div className="node-subtitle">{data.subLabel}</div>}
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}

export function EmailNode({ id, data }) {
    return (
        <div className="workflow-node-box email-node" style={{ minWidth: '350px', position: 'relative' }}>
            <button className="delete-node-button" onClick={() => data.onDelete(id)}>
                X
            </button>
            <div className="node-title">{data.label || 'Email'}</div>
            {data.subLabel && <div className="node-subtitle">{data.subLabel}</div>}
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}

export function ConditionalNode({ id, data }) {
    return (
        <div className="workflow-node-box conditional-node" style={{ minWidth: '350px', position: 'relative' }}>
            <button className="delete-node-button" onClick={() => data.onDelete(id)}>
                X
            </button>
            <div className="node-title">{data.label || 'Conditional'}</div>
            {data.subLabel && <div className="node-subtitle">{data.subLabel}</div>}
            <Handle type="target" position={Position.Top} />
            {/* Two output handles for conditional outcomes */}
            <Handle
                type="source"
                position={Position.Left}
                id="if-output"
                style={{ top: '70%', background: '#2ecc71' }}
            />
            <Handle
                type="source"
                position={Position.Right}
                id="else-output"
                style={{ top: '70%', background: '#e74c3c' }}
            />
        </div>
    );
}

export function DelayNode({ id, data }) {
    return (
        <div className="workflow-node-box delay-node" style={{ minWidth: '350px', position: 'relative' }}>
            <button className="delete-node-button" onClick={() => data.onDelete(id)}>
                X
            </button>
            <div className="node-title">{data.label || 'Delay'}</div>
            {data.subLabel && <div className="node-subtitle">{data.subLabel}</div>}
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
}
